import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCircleNotch} from '@fortawesome/free-solid-svg-icons'

const Preloader = ({show}) => {

    const [view, setView] = useState(false)
    useEffect(() => {
        setView(show)
    }, [show])

    return view && <div id="preloader-container">
                    <div id="preloader">
                        <FontAwesomeIcon icon={faCircleNotch} spin size="3x" />
                    </div>
                </div>
    
}

export default Preloader